<template>
  <div class="list-box">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRenYuanList"
      data-title="核算审批"
    >
      <el-segmented
        v-model="state.params.is_approve"
        :props="{
          label: 'Text',
          value: 'Key',
        }"
        :options="[
          { Key: 0, Text: '待审批' },
          { Key: 1, Text: '已审批' },
        ]"
        :empty-values="[null, undefined, 0]"
        class="c-segmented"
        @change="onLoad()"
      />
      <el-input
        v-model="state.params.keywords"
        class="c-search-white"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        ref="tableDom"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column :width="260">
          <template #header>
            <el-tooltip
              content="当步骤状态为待审批状态时，操作人为待操作的人员；反之操作人为已操作的人员"
            >
              <div class="flex items-center gap-x-1 cursor-pointer">
                <div
                  class="c-table-col-header"
                  label1="当前步骤"
                  label2="操作人时间"
                />
                <el-icon><QuestionFilled /></el-icon>
              </div>
            </el-tooltip>
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <ul class="flex gap-x-1 items-center">
                  <text>
                    {{ row.flowApproveStep?.step_name }}
                  </text>
                  <c_status
                    arrName="Common_Check_Status"
                    :value="row.flowApproveStep?.status"
                    :key="row.flowApproveStep?.status"
                  />
                </ul>
              </template>
              <template #bottom>
                <ul class="flex gap-x-1 items-baseline">
                  <text class="text-gray-600">
                    {{ row.flowApproveStep?.approve_admin_name }}
                  </text>
                  <text class="ml-1">
                    {{ row.flowApproveStep?.approve_department_name }}
                  </text>
                </ul>
                <ul class="flex gap-x-1 items-center">
                  <text v-if="row?.flowApproveStep?.approve_time">
                    {{ row.flowApproveStep?.approve_time }}
                  </text>
                </ul>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column :width="300">
          <template #header>
            <div
              class="c-table-col-header"
              label1="会议名称"
              label2="会议时间"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              :value2="row.meeting?.start_date + ' ~ ' + row.meeting?.end_date"
            >
              <template #top>
                <div
                  class="flex items-center gap-x-2 text-green-700 cursor-pointer hover:underline"
                >
                  <strong>{{
                    row.meeting?.name + "[" + row.meeting?.number + "]"
                  }}</strong>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column align="right">
          <template #header>
            <div
              class="c-table-col-header float-right"
              label1="应收款"
              label2="欠款"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <c_money
                  :value="row.receivable_amount"
                  :key="row.receivable_amount"
                  :prefix="false"
                  class="float-right"
                  color="#080"
                />
              </template>
              <template #bottom>
                <c_money
                  :value="row.uncollected_amount"
                  :key="row.uncollected_amount"
                  :prefix="false"
                  class="float-right mt-1"
                  color="#a2a2a2"
                  :size="12"
                />
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          prop="bill_amount"
          label="报账总金额(乙方)"
          :formatter="$tab_PriceFormat"
          align="right"
        />
        <el-table-column :width="220" align="right">
          <template #header>
            <div
              class="c-table-col-header float-right"
              label1="采购金额合计"
              label2="税务成本"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <c_money
                  :value="row.purchase_amount"
                  :key="row.purchase_amount"
                  :prefix="false"
                  class="float-right"
                  color="#606266"
                />
              </template>
              <template #bottom>
                <c_money
                  :value="row.cost_tax_fee_amount"
                  :key="row.cost_tax_fee_amount"
                  :prefix="false"
                  class="float-right mt-1"
                  color="#a2a2a2"
                  :size="12"
                />
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column :width="220" align="right">
          <template #header>
            <div
              class="c-table-col-header float-right"
              label1="毛利"
              label2="会议结转收入"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <c_money
                  :value="row.gross_profit"
                  :key="row.gross_profit"
                  :prefix="false"
                  class="float-right"
                  color="#606266"
                />
              </template>
              <template #bottom>
                <c_money
                  :value="row.forward_amount"
                  :key="row.forward_amount"
                  :prefix="false"
                  class="float-right mt-1"
                  color="#a2a2a2"
                  :size="12"
                />
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          prop="intro"
          label="申请说明"
          :formatter="$tab_TextFormat"
          :min-width="160"
        />
        <el-table-column label="申请人" :width="160">
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <text>{{ row?.add_admin_name }}</text>
                <text class="text-gray-400 text-xs ml-1">{{
                  row?.add_department_name
                }}</text>
              </template>
              <template #bottom>
                <text>{{ row?.create_time }}</text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="120">
          <template #default="{ row }">
            <el-button
              v-if="row.status == 0"
              type="primary"
              :icon="Select"
              link
              @click.stop="
                delete state.search;
                state.selectId = row.id;
                state.showDetail = true;
              "
              >审批
            </el-button>
            <el-button
              v-else
              type="success"
              :icon="Search"
              link
              @click.stop="
                state.search = true;
                state.selectId = row.id;
                state.showDetail = true;
              "
              >查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showDetail"
    title="核算审批"
    class="c-el-dialog h-full"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
    style="width: 85%"
  >
    <c_detail
      :id="state.selectId"
      :search="state.search"
      @close="
        state.showDetail = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { meetingacounting_page } from "@/http/hesuanshenpi";

import c_detail from "./Detail.vue";

class InitFormData {
  params = {
    page: 1,
    is_approve: 0,
  };
}

export default {
  props: {
    meeting_id: Number,
  },
  components: {
    c_detail,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      meetingacounting_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    return {
      state,
      props,
      tableDom,
      onLoad,
    };
  },
};
</script>

<style lang="scss" scoped></style>
